import { twMerge } from 'tailwind-merge';

// import BookingIcon from '../../../assets/svg/BookingIcon';
// import CalendarIcon from '../../../assets/svg/CalendarIcon';
// import ConfirmIcon from '../../../assets/svg/ConfirmIcon';
import {
  ChartAppointmentOutcomes,
  ChartDialActivities,
  ChartDialOutcomes,
  // ChartNumber,
} from '../index';

const getTitle = (tenantName, callerId) => {
  if (!tenantName && !callerId) return '';
  if (!!tenantName && !callerId) return tenantName;
  return `${tenantName}; ${callerId}`;
};

export const DashboardContent = ({
  dashboardData,
  filters,
  callerId = null,
  tenantName = null,
  pdfMode = false,
}) => {
  return (
    <div
      className={twMerge(
        'grid gap-5 grid-cols-[repeat(auto-fit,minmax(590px,1fr))] overflow-auto',
        pdfMode &&
          'w-[1024px] h-[1250px] flex flex-col gap-5 justify-center p-10 pt-20 overflow-hidden',
      )}
    >
      {pdfMode && (
        <div className="flex justify-between">
          <span className="text-[16px]/[24px] text-base-1000 text-medium">
            {getTitle(tenantName, callerId)}
          </span>
          <span className="text-[16px]/[24px] text-base-1000">
            {filters.startDate
              ? `${filters.startDate} - ${filters.endDate}`
              : 'Lifetime'}
          </span>
        </div>
      )}
      <div className="flex flex-col gap-5">
        <ChartDialActivities data={dashboardData.dialActivities} />
        <ChartDialOutcomes
          data={dashboardData.dialOutcomes}
          filters={filters}
          isActionsVisible={!pdfMode}
        />
      </div>
      <div className="flex flex-col gap-5">
        {/* TODO: https://darly-solutions.slack.com/archives/C07QUL9TDJT/p1752790163327199 */}
        {/* <div className="grid gap-5 grid-cols-3">
          <ChartNumber
            title="Performed"
            Icon={ConfirmIcon}
            data={dashboardData.appointmentWidgets.performed}
          />
          <ChartNumber
            title="Rescheduled"
            Icon={BookingIcon}
            data={dashboardData.appointmentWidgets.rescheduled}
          />
          <ChartNumber
            title="Upcoming"
            Icon={CalendarIcon}
            data={dashboardData.appointmentWidgets.upcoming}
          />
        </div> */}
        <ChartAppointmentOutcomes data={dashboardData.appointmentOutcomes} />
      </div>
    </div>
  );
};
